import type { PageBlock } from '@impact/types';

export interface Snapshot {
  blocks: PageBlock[];
}

export function takeSnapshot(blocks: PageBlock[]): Snapshot {
  return { blocks: structuredClone(blocks) };
}

export function applySnapshot(snap: Snapshot): PageBlock[] {
  return structuredClone(snap.blocks);
}
